import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="header">
      <div className="logo">
        <h1>CI Offshore</h1>
        <p>Restriction Application</p>
      </div>
      <nav className="nav">
        <Link to="/">Home</Link>
        <a>How It Works</a>
        {/* <a>Guide</a> */}
        {/* <button>Search</button> */}
      </nav>
    </header>
  );
};

export default Header;